import { Component, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { HeaderAppComponent } from '../../headers/header-app/header-app.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { FormTemplateComponent } from '../../../shared/screen-templates/form-template/form-template.component';
import { PayeeHorizontalLineComponent } from '../../../shared/payee-horizontal-line/payee-horizontal-line.component';

@Component({
  selector: 'app-verify-token-expired',
  templateUrl: './verify-token-expired.component.html',
  styleUrls: ['./verify-token-expired.component.scss'],
  imports: [
    HeaderAppComponent,
    PayeeIconComponent,
    FormTemplateComponent,
    PayeeHorizontalLineComponent,
    TranslateModule,
  ],
})
export class VerifyTokenExpiredComponent {
  private authService = inject(AuthService);
  private snackbar = inject(MatSnackBar);
  private translate = inject(TranslateService);

  resendPressed = false;

  async resendVerifyEmail() {
    if (this.resendPressed) {
      return;
    }
    try {
      this.resendPressed = true;
      await this.authService.resendVerifyEmail();
      this.snackbar.open(
        this.translate.instant('VERIFY_TOKEN_EXPIRED.RESEND_SUCCESS'),
        this.translate.instant('OK'),
        {
          duration: 5000,
        },
      );
    } catch (error) {
      console.error('Error while sending verify email', error);
      this.snackbar.open(
        this.translate.instant('ERROR_MESSAGES.UNKNOWN_ERROR'),
        this.translate.instant('OK'),
        {
          duration: 5000,
        },
      );
    } finally {
      setTimeout(() => (this.resendPressed = false), 15000);
    }
  }
}
